module.exports = __webpack_public_path__ + "static/media/problem_primary.cff6c922.svg";